import { Tabs } from "@mantine/core";
export const tabsProps = Tabs.extend({});
